module.exports = __webpack_public_path__ + "img/ny.964c8e21.jpg";